<template>
  <div class="record-page">
    <!-- 顶部导航栏 -->
    <div class="top-header">
      <div class="nav-left">
        <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      </div>
      <div class="nav-title">星耀榜单</div>
      <div class="nav-right">
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          class="home-link"
        >
          <van-icon name="wap-home" size="20" class="home-icon" />
        </a>
      </div>
    </div>

    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="title">
        <span class="wse">星耀</span><span class="open">明星榜</span>
      </div>
    </div>

    <!-- 下拉刷新容器 -->
    <van-pull-refresh
      v-if="isHy === '1'"
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="!isAtTop"
      success-text="刷新成功"
      pulling-text="下拉即可刷新..."
      loosing-text="释放即可刷新..."
      loading-text="加载中..."
      success-duration="1500"
      head-height="50"
    >
      <!-- 排行榜选择器 -->
      <div class="ranking-tabs-wrapper">
        <van-row gutter="12" class="ranking-tabs">
          <van-col span="8" v-if="false">
            <div
              :class="phlx === 'ALL' ? 'tab-item active' : 'tab-item'"
              @click="phlxTab('ALL')"
            >
              总排名
            </div>
          </van-col>
          <van-col span="12">
            <div
              :class="phlx === 'S' ? 'tab-item active' : 'tab-item'"
              @click="phlxTab('S')"
            >
              单打排名
            </div>
          </van-col>
          <van-col span="12">
            <div
              :class="phlx === 'D' ? 'tab-item active' : 'tab-item'"
              @click="phlxTab('D')"
            >
              双打排名
            </div>
          </van-col>
        </van-row>
      </div>

      <!-- 筛选器区域 -->
      <div class="filter-section">
        <div class="filter-row">
          <!-- 组别筛选 -->
          <div class="filter-item">
            <van-dropdown-menu active-color="#ff4444">
              <van-dropdown-item
                v-model="selectedGroup"
                :options="groupOptions"
                @change="onGroupChange"
              >
                <template #title>
                  <div class="dropdown-title">
                    <van-icon name="cluster-o" />
                    <span>{{ getGroupLabel() }}</span>
                  </div>
                </template>
              </van-dropdown-item>
            </van-dropdown-menu>
          </div>

          <!-- 项目筛选 -->
          <div class="filter-item">
            <van-dropdown-menu active-color="#ff4444">
              <van-dropdown-item
                v-model="selectedProject"
                :options="projectOptions"
                @change="onProjectChange"
              >
                <template #title>
                  <div class="dropdown-title">
                    <van-icon name="medal-o" />
                    <span>{{ getProjectLabel() }}</span>
                  </div>
                </template>
              </van-dropdown-item>
            </van-dropdown-menu>
          </div>

          <!-- 年份筛选 -->
          <div class="filter-item">
            <van-dropdown-menu active-color="#ff4444">
              <van-dropdown-item
                v-model="selectedYear"
                :options="yearOptions"
                @change="onYearChange"
              >
                <template #title>
                  <div class="dropdown-title">
                    <van-icon name="calendar-o" />
                    <span>{{ getYearLabel() }}</span>
                  </div>
                </template>
              </van-dropdown-item>
            </van-dropdown-menu>
          </div>
        </div>
      </div>

      <!-- 项目切换 -->
      <div class="event-selector">
        <div
          :class="bdlx === 'ZFB' ? 'event-item active' : 'event-item'"
          @click="bdlxTab('ZFB')"
        >
          <span>总分榜</span>
          <div class="underline" v-if="bdlx === 'ZFB'"></div>
        </div>
        <div
          :class="bdlx === 'ZCISHU' ? 'event-item active' : 'event-item'"
          @click="bdlxTab('ZCISHU')"
        >
          <span>总站数榜</span>
          <div class="underline" v-if="bdlx === 'ZCISHU'"></div>
        </div>
        <div
          :class="bdlx === 'ZCS' ? 'event-item active' : 'event-item'"
          @click="bdlxTab('ZCS')"
        >
          <span>总场数榜</span>
          <div class="underline" v-if="bdlx === 'ZCS'"></div>
        </div>
        <div
          :class="bdlx === 'SLV' ? 'event-item active' : 'event-item'"
          @click="bdlxTab('SLV')"
        >
          <span>胜率榜</span>
          <div class="underline" v-if="bdlx === 'SLV'"></div>
        </div>
      </div>

      <!-- 搜索框 -->
      <div class="search-container">
        <van-search
          v-model="searchKeyword"
          placeholder="搜索运动员姓名"
          background="#333"
          shape="round"
          @input="onSearchInput"
          @clear="onSearchClear"
        >
          <template #left-icon>
            <van-icon name="search" color="#999" />
          </template>
        </van-search>
      </div>

      <!-- 组别记录列表 -->
      <div class="group-records">
        <!-- 无搜索结果提示 -->
        <div
          v-if="rankedResultList.length === 0 && searchKeyword"
          class="no-result"
        >
          <van-icon name="search" size="48" color="#666" />
          <p>未找到"{{ searchKeyword }}"相关的运动员</p>
        </div>

        <!-- 空状态提示（无数据且无搜索词） -->
        <div
          v-if="
            rankedResultList.length === 0 &&
              !searchKeyword &&
              isShowEmpty === '1'
          "
          class="empty-state"
        >
          <div class="empty-icon">
            <van-icon name="records" size="64" color="#666" />
          </div>
          <div class="empty-text">暂无榜单数据</div>
          <div class="empty-hint">当前筛选条件下暂无运动员数据</div>
        </div>

        <!-- 榜单记录列表 -->
        <div
          :class="[
            'group-record-card',
            'card-enter',
            getRankingClass(item.RK - 1)
          ]"
          v-for="(item, index) in rankedResultList"
          :key="index"
          :style="{ animationDelay: `${index * 0.1}s` }"
          @click="goToPlayerDetail(item)"
        >
          <div class="athlete-section">
            <div class="athlete-avatar">
              <van-image
                class="avatar"
                round
                width="30px"
                height="30px"
                src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
              />
            </div>
            <div class="athlete-name">{{ item.RYXM }}</div>
          </div>
          <div class="update-time-tag" v-if="item.UPTTM">
            <span>{{ item.UPTTM }}</span>
          </div>
          <div class="group-info">
            <div class="medal-icon" v-if="item.RK <= 3">
              <van-icon
                name="medal"
                :color="getMedalColor(item.RK - 1)"
                size="24px"
              />
            </div>
            <div class="ranking-display">
              {{ `第${item.RK}名` }}
            </div>
          </div>

          <div class="record-section">
            <div class="record-time">
              {{
                bdlx === "ZFB"
                  ? item.ZDF + "分"
                  : bdlx === "SLV"
                  ? item.SLVNAME
                  : bdlx === "ZCS"
                  ? item.CSZCHANGSHU + "场"
                  : "共" + item.CSZCIS + "站"
              }}
            </div>
          </div>

          <!-- 查看详情箭头 -->
          <div class="detail-arrow">
            <van-icon name="arrow" size="16" color="rgba(255, 255, 255, 0.6)" />
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 返回顶部悬浮按钮 -->
    <transition name="fade-scale">
      <div v-show="showBackTop" class="back-to-top-fab" @click="scrollToTop">
        <div class="fab-text">顶部</div>
      </div>
    </transition>

    <!-- 会员推广横幅 -->
    <div
      v-if="isHy === '0'"
      class="vip-promotion-banner"
      @click="goToMemberBenefits"
    >
      <div class="vip-banner-bg">
        <div class="vip-banner-content">
          <div class="vip-icon-wrapper">
            <van-icon name="vip-card" size="32" class="vip-icon" />
            <div class="vip-sparkle">✨</div>
          </div>
          <div class="vip-text-content">
            <div class="vip-title">
              <span class="vip-highlight">办会员</span>
              <span class="vip-separator">·</span>
              <span class="vip-highlight">看生涯</span>
            </div>
            <div class="vip-subtitle">开通会员即可查看完整生涯数据</div>
          </div>
          <div class="vip-arrow">
            <van-icon name="arrow" size="18" />
          </div>
        </div>
        <div class="vip-banner-shine"></div>
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { LoadingCom },
  name: "MeNewIndex",

  data() {
    return {
      isShowEmpty: "1",
      refreshing: false, // 下拉刷新状态
      showBackTop: false, // 显示返回顶部按钮
      routeValue: "", // 路由值
      phlx: "S",
      bdlx: "ZFB",
      ryInfo: {
        NIC: "点击登录",
        TEL: "",
        TELEN: "",
        isLogin: false
      },
      openIdEn: "",
      op: "wapGL",
      resultList: [],
      searchKeyword: "",
      // 筛选器数据
      selectedGroup: "all",
      selectedProject: "all",
      selectedYear: "all",
      groupOptions: this.generateGroupOptions(),
      // 单打项目选项
      singleProjectOptions: [
        { text: "全部项目", value: "all" },
        { text: "男单", value: "MS" },
        { text: "女单", value: "WS" },
        { text: "混单", value: "XS" }
      ],
      // 双打项目选项
      doubleProjectOptions: [
        { text: "全部项目", value: "all" },
        { text: "男双", value: "MD" },
        { text: "女双", value: "WD" },
        { text: "混双", value: "XD" }
      ],
      yearOptions: [],
      isHy: "1",
      uis: "",
      isAtTop: true // 是否在顶部
    };
  },

  computed: {
    // 根据排名类型动态返回项目选项
    projectOptions() {
      if (this.phlx === "S") {
        // 单打排名
        return this.singleProjectOptions;
      } else if (this.phlx === "D") {
        // 双打排名
        return this.doubleProjectOptions;
      }
      // 默认返回单打选项
      return this.singleProjectOptions;
    },
    filteredResultList() {
      if (!this.searchKeyword || this.searchKeyword.trim() === "") {
        return this.resultList;
      }
      const keyword = this.searchKeyword.trim().toLowerCase();
      return this.resultList.filter(item => {
        return item.RYXM && item.RYXM.toLowerCase().includes(keyword);
      });
    },
    // 计算带并列的排名列表
    rankedResultList() {
      const list = this.filteredResultList;
      if (list.length === 0) return [];

      // 获取当前榜单类型的值字段
      const valueField =
        this.bdlx === "ZFB"
          ? "ZDF"
          : this.bdlx === "SLV"
          ? "SLV"
          : this.bdlx === "ZCS"
          ? "CSZCHANGSHU"
          : "CSZCIS";

      // 计算每个项目的排名
      let currentRank = 1;
      let previousValue = null;
      let sameRankCount = 0;

      return list.map((item, index) => {
        const currentValue = item[valueField];

        if (index === 0) {
          // 第一名
          previousValue = currentValue;
          return { ...item, displayRank: 1, actualRank: 1 };
        }

        if (currentValue === previousValue) {
          // 值相同，并列排名
          sameRankCount++;
          return { ...item, displayRank: currentRank, actualRank: index + 1 };
        } else {
          // 值不同，更新排名
          currentRank = index + 1;
          previousValue = currentValue;
          sameRankCount = 0;
          return { ...item, displayRank: currentRank, actualRank: index + 1 };
        }
      });
    }
  },

  created() {
    this.utilPost = this.$util.handler;
  },

  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    this.checkLogin();
    this.initYearOptions();
    this.mainData();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    // 处理滚动事件
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.showBackTop = scrollTop > 300;
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop = scrollTop <= 10;
    },
    // 返回顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    // 生成组别选项（6岁到70岁）
    generateGroupOptions() {
      const options = [{ text: "全部组别", value: "all" }];
      for (let age = 6; age <= 70; age++) {
        options.push({
          text: `${age}岁组`,
          value: age.toString()
        });
      }
      return options;
    },
    // 初始化年份选项
    initYearOptions() {
      const currentYear = new Date().getFullYear();
      const startYear = 2023;
      this.yearOptions = [{ text: "全部年份", value: "all" }];

      // 从当前年份到2023年（倒序）
      for (let year = currentYear; year >= startYear; year--) {
        this.yearOptions.push({
          text: `${year}年`,
          value: year.toString()
        });
      }
    },
    // 获取组别标签
    getGroupLabel() {
      const option = this.groupOptions.find(
        item => item.value === this.selectedGroup
      );
      return option ? option.text : "组别";
    },
    // 获取项目标签
    getProjectLabel() {
      const option = this.projectOptions.find(
        item => item.value === this.selectedProject
      );
      return option ? option.text : "项目";
    },
    // 获取年份标签
    getYearLabel() {
      const option = this.yearOptions.find(
        item => item.value === this.selectedYear
      );
      return option ? option.text : "年份";
    },
    // 组别筛选变化
    // 组别筛选变化
    onGroupChange(value) {
      console.log("组别筛选:", value);

      // 如果选中了具体的组别（不是"全部"），并且年份还是"全部"，则自动选中最大年份
      if (value !== "all" && this.selectedYear === "all") {
        // 找到yearOptions中第一个非"全部"的年份（即最大年份）
        const maxYearOption = this.yearOptions.find(
          option => option.value !== "all"
        );
        if (maxYearOption) {
          this.selectedYear = maxYearOption.value;
          console.log("自动选中最大年份:", this.selectedYear);
        }
      }

      this.mainData();
    },
    // 项目筛选变化
    onProjectChange(value) {
      console.log("项目筛选:", value);
      this.mainData();
    },
    // 年份筛选变化
    onYearChange(value) {
      console.log("年份筛选:", value);
      this.mainData();
    },
    // 下拉刷新处理
    onRefresh() {
      // 重新加载当前榜单数据
      this.mainData();
    },
    goBack() {
      this.$router.go(-1);
    },
    // 跳转到会员权益页面
    goToMemberBenefits() {
      this.$router.push("/memberBenefits");
    },
    // 跳转到球员成长轨迹页面
    goToPlayerDetail(item) {
      // 跳转到 MeQygjIndex 页面，并传递球员身份证号
      var busData = {
        SFZHEN: item.SFZH
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getPlayerInfo" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost
        .sendPost()
        .then(data => {
          if (!data.isSuccess) {
            alert(data.msg);
            this.refreshing = false;
            return;
          }
          this.$router.push({
            path: "/meQygjIndex",
            query: {
              sfzh: item.SFZH
            }
          });
          return;
          if (data.content.ISZY) {
            if (data.content.ISZY === "Y") {
              this.$router.push({
                path: "/meQygjIndex",
                query: {
                  sfzh: item.SFZH
                }
              });
            } else {
              this.$toast("该球员未开启生涯数据查看权限");
            }
          } else {
            this.$toast("该球员未开启生涯数据查看权限");
          }
        })
        .catch(error => {
          console.error("加载数据失败:", error);
          this.refreshing = false;
        });
    },
    phlxTab(type) {
      this.phlx = type;
      // 切换排名类型时，重置项目筛选为"全部"
      this.selectedProject = "all";
      this.mainData();
    },
    bdlxTab(type) {
      this.bdlx = type;
      this.mainData();
    },
    checkLogin() {
      var openIdEn = localStorage.getItem("openIdEn");
      if (
        openIdEn === undefined ||
        openIdEn === null ||
        openIdEn.length === 0
      ) {
        var that = this;
        this.utilPost.getOpenId(function(openId) {
          var ryInfoLocal = localStorage.getItem("ryInfo");
          if (
            ryInfoLocal === undefined ||
            ryInfoLocal === "" ||
            ryInfoLocal === null ||
            ryInfoLocal.length === 0
          ) {
            that.$router.push({ path: "/loginIndex" });
            return;
          } else {
            this.uis = ryInfoLocal;
          }
        });
      } else {
        var ryInfoLocal = localStorage.getItem("ryInfo");
        if (
          ryInfoLocal === undefined ||
          ryInfoLocal === "" ||
          ryInfoLocal === null ||
          ryInfoLocal.length === 0
        ) {
          this.$router.push({ path: "/loginIndex" });
        } else {
          this.uis = ryInfoLocal;
        }
      }
      this.openIdEn = openIdEn;
    },
    mainData() {
      var busData = {
        phlx: this.phlx,
        bdlx: this.bdlx,
        group: this.selectedGroup,
        project: this.selectedProject,
        year: this.selectedYear,
        TELEN: this.uis.TELEN
      };
      this.resultList = [];
      this.isShowEmpty = "0";
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "syBang" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost
        .sendPost()
        .then(data => {
          // alert(JSON.stringify(data));
          this.isShowEmpty = "1";
          if (!data.isSuccess) {
            alert(data.msg);
            this.refreshing = false;
            return;
          }
          this.isHy = data.lsData.isHy;
          this.resultList = data.content;
          this.refreshing = false;

          // 如果是刷新操作，显示成功提示
          if (this.refreshing === false && data.isSuccess) {
            // 刷新成功提示由组件自动显示
          }
        })
        .catch(error => {
          console.error("加载数据失败:", error);
          this.refreshing = false;
        });
    },
    getMedalColor(index) {
      // 根据排名返回不同的奖牌颜色
      switch (index) {
        case 0: // 第1名 - 金牌
          return "#FFD700";
        case 1: // 第2名 - 银牌
          return "#C0C0C0";
        case 2: // 第3名 - 铜牌
          return "#CD7F32";
        default:
          return "#FFD700";
      }
    },
    getRankingClass(index) {
      // 根据排名返回不同的CSS类
      switch (index) {
        case 0: // 第1名 - 金牌
          return "gold";
        case 1: // 第2名 - 银牌
          return "silver";
        case 2: // 第3名 - 铜牌
          return "bronze";
        default:
          return "normal";
      }
    },
    onSearchInput() {
      // 搜索输入时的处理（可以添加防抖等优化）
    },
    onSearchClear() {
      // 清空搜索
      this.searchKeyword = "";
    }
  }
};
</script>

<style scoped>
/* 防止横向滚动 - 全局设置 */
* {
  box-sizing: border-box;
}

/* 整体页面样式 */
.record-page {
  min-height: 100vh;
  background: #2a2a2a;
  color: white;
  padding-bottom: 80px;
  overflow-x: hidden; /* 只在当前组件禁止横向滚动 */
  max-width: 100vw; /* 限制最大宽度 */
  position: relative; /* 为 fixed 元素提供定位上下文 */
}

/* 顶部导航栏 */
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #2a2a2a;
  position: relative;
}

.nav-left {
  width: 60px;
  display: flex;
  justify-content: flex-start;
}

.back-icon {
  font-size: 24px;
  color: #fff;
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.nav-right {
  width: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.home-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.home-icon {
  color: #fff;
  transition: all 0.3s ease;
}

.home-icon:hover {
  transform: scale(1.1);
  color: #667eea;
}

.nav-icons {
  display: flex;
  gap: 4px;
}

.icon-dot {
  width: 4px;
  height: 4px;
  background: #fff;
  border-radius: 50%;
}

.record-icon {
  width: 32px;
  height: 32px;
  background: #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

/* 主记录卡片 (红色) */
.main-record-card {
  margin: 16px;
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(220, 53, 69, 0.3);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.record-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.record-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(220, 53, 69, 0.8);
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 2px;
}

.record-venue {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(220, 53, 69, 0.8);
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
}

.record-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.athlete-avatar {
  position: relative;
}

.medal-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #8b5a00;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.athlete-name {
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.mr-badge {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
}

.record-time {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

/* 标签栏 */
.section-tabs {
  display: flex;
  justify-content: space-around;
  padding: 16px;
  background: #000;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.tab-item.active .tab-text {
  color: #fff;
  font-weight: 600;
}

.tab-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
}

.tab-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}

.tab-badge.gr {
  background: linear-gradient(135deg, #ff8c00 0%, #ffa500 100%);
}

.tab-badge.yb {
  background: linear-gradient(135deg, #e91e63 0%, #f06292 100%);
}

/* 组别记录列表 */
.group-records {
  padding: 18px 13px;
}

.group-record-card {
  background: linear-gradient(135deg, rgb(24, 95, 155) 0%, #333333 100%);
  border-radius: 0;
  margin-bottom: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(74, 74, 74, 0.3);
  position: relative;
  clip-path: polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%);
  transform: skewX(-2deg);
  gap: 12px;
  min-height: 50px;
  border-right: 2px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.group-record-card::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.group-record-card:active::after {
  width: 300px;
  height: 300px;
}

.group-record-card:hover {
  transform: skewX(-2deg) translateY(-2px) translateX(3px);
  box-shadow: 0 4px 12px rgba(74, 74, 74, 0.5),
    0 0 20px rgba(102, 126, 234, 0.3);
  border-right: 3px solid rgba(255, 255, 255, 0.5);
  background: linear-gradient(135deg, rgb(34, 115, 175) 0%, #444444 100%);
}

.group-record-card:active {
  transform: skewX(-2deg) translateY(0) scale(0.98);
  box-shadow: 0 2px 6px rgba(74, 74, 74, 0.4);
}

.athlete-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 70px;
  margin-right: 8px;
}

.athlete-name {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  color: #fff;
}

.group-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
}

.group-title {
  font-size: 14px;
  line-height: 1.2;
}

.medal-icon {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 2px;
  margin-left: 7px;
}

.ranking-display {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  text-align: left;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

.record-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 60px;
}

.record-time {
  font-size: 16px;
  line-height: 1.2;
}

/* 查看详情箭头 */
.detail-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding-left: 8px;
  transition: all 0.3s ease;
}

.group-record-card:hover .detail-arrow {
  transform: translateX(5px);
}

.group-record-card:hover .detail-arrow .van-icon {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* 更新时间标签 */
.update-time-tag {
  position: absolute;
  top: -4px;
  right: -2px;
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  color: #fff;
  padding: 2px 8px;
  font-size: 9px;
  font-weight: 600;
  z-index: 10;
  transform: skewX(-2deg);
  box-shadow: 0 2px 6px rgba(255, 68, 68, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  clip-path: polygon(4px 0%, 100% 0%, calc(100% - 4px) 100%, 0% 100%);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 16px;
}

.update-time-tag span {
  display: block;
  transform: skewX(2deg);
  line-height: 1;
  white-space: nowrap;
  text-align: right;
}

/* 冠军 - 金色背景 (调暗) */
.group-record-card.gold {
  background: linear-gradient(90deg, #b8860b 0%, #8b4a2b 100%);
  box-shadow: 0 2px 8px rgba(184, 134, 11, 0.4);
  border-right: 2px solid rgba(255, 215, 0, 0.5);
}

/* 亚军 - 银色背景 (调暗) */
.group-record-card.silver {
  background: linear-gradient(90deg, #808080 0%, #8b4a2b 100%);
  box-shadow: 0 2px 8px rgba(128, 128, 128, 0.4);
  border-right: 2px solid rgba(192, 192, 192, 0.6);
}

/* 季军 - 铜色背景 (调暗) */
.group-record-card.bronze {
  background: linear-gradient(90deg, #8b4513 0%, #8b4a2b 100%);
  box-shadow: 0 2px 8px rgba(139, 69, 19, 0.4);
  border-right: 2px solid rgba(205, 127, 50, 0.5);
}

/* 普通排名 - 默认背景 (调暗) */
.group-record-card.normal {
  background: linear-gradient(90deg, rgb(20, 70, 120) 0%, #8b4a2b 100%);
  box-shadow: 0 2px 8px rgba(50, 50, 50, 0.3);
  border-right: 2px solid rgba(100, 150, 200, 0.4);
}

.group-record-card > * {
  transform: skewX(2deg);
}

/* 奖牌颜色更新 */
.medal-badge.gold {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  color: #8b5a00;
}

.medal-badge.silver {
  background: linear-gradient(135deg, #c0c0c0 0%, #e5e5e5 100%);
  color: #666;
}

.medal-badge.bronze {
  background: linear-gradient(135deg, #cd7f32 0%, #d4a574 100%);
  color: #5d3a19;
}

.group-info {
  flex: 1;
}

.group-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.athlete-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 16px;
}

.record-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.gr-badge {
  background: linear-gradient(135deg, #ff8c00 0%, #ffa500 100%);
  color: #fff;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);
}

/* 顶部标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  border-bottom: 1px solid #333;
}

.title {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.wse {
  font-size: 24px;
  font-weight: 700;
  color: #ff4444;
  text-shadow: 0 2px 4px rgba(255, 68, 68, 0.3);
}

.open {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-left: 4px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-actions .van-icon {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  transition: color 0.3s ease;
}

.header-actions .van-icon:hover {
  color: #ff4444;
}

.record-btn {
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 68, 68, 0.3);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.record-btn:hover {
  transform: scale(1.1);
}

.record-btn .van-icon {
  color: #fff !important;
  font-size: 16px;
}

/* 排行榜标签选择器 */
.ranking-tabs-wrapper {
  background: #2a2a2a;
  padding-left: 15px;
  padding-right: 30px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #333;
}

/* 筛选器区域 */
.filter-section {
  background: #2a2a2a;
  padding: 12px 16px;
  border-bottom: 1px solid #333;
}

.filter-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.filter-item {
  flex: 1;
}

.filter-item /deep/ .van-dropdown-menu {
  background: transparent;
}

.filter-item /deep/ .van-dropdown-menu__bar {
  background: linear-gradient(135deg, #333 0%, #3a3a3a 100%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  height: 40px;
  border: 1px solid #444;
}

.filter-item /deep/ .van-dropdown-menu__title {
  color: #fff;
  font-size: 13px;
  padding: 0 12px;
}

.filter-item /deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent #fff #fff;
}

.filter-item /deep/ .van-dropdown-item {
  background: #2a2a2a;
}

.filter-item /deep/ .van-dropdown-item__option {
  color: #fff;
}

.filter-item /deep/ .van-dropdown-item__option--active {
  color: #ff4444;
}

.filter-item /deep/ .van-cell {
  background: #333;
  color: #fff;
}

.filter-item /deep/ .van-cell:hover {
  background: #3a3a3a;
}

.dropdown-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.dropdown-title .van-icon {
  font-size: 16px;
  color: #ff4444;
}

.dropdown-title span {
  color: #fff;
  font-weight: 500;
}

.ranking-tabs {
  /* van-row 自带样式，无需额外设置 */
}

.ranking-tabs .van-col {
  /* van-col 自带样式，gutter会自动处理间距 */
}

.ranking-tabs .tab-item {
  padding: 10px 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 6px;
  position: relative;
  text-align: center;
  opacity: 0.6;
  transform: scale(0.95);
  border: 2px solid transparent;
  width: 100%;
  display: block;
}

/* 总排名 - 红色 (未选中状态) */
.ranking-tabs .van-col:nth-child(1) .tab-item {
  background: linear-gradient(
    135deg,
    rgba(255, 68, 68, 0.3) 0%,
    rgba(204, 51, 51, 0.3) 100%
  );
  color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 1px 4px rgba(255, 68, 68, 0.2);
}

.ranking-tabs .van-col:nth-child(1) .tab-item:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 68, 68, 0.5) 0%,
    rgba(204, 51, 51, 0.5) 100%
  );
  opacity: 0.8;
  transform: scale(0.98);
}

/* 总排名 - 红色 (选中状态) */
.ranking-tabs .van-col:nth-child(1) .tab-item.active {
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(255, 68, 68, 0.6);
  opacity: 1;
  transform: scale(1.05) translateY(-2px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

/* 单打排名 - 橙色 (未选中状态) */
.ranking-tabs .van-col:nth-child(2) .tab-item {
  background: linear-gradient(
    135deg,
    rgba(255, 140, 0, 0.3) 0%,
    rgba(230, 115, 0, 0.3) 100%
  );
  color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 1px 4px rgba(255, 140, 0, 0.2);
}

.ranking-tabs .van-col:nth-child(2) .tab-item:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 140, 0, 0.5) 0%,
    rgba(230, 115, 0, 0.5) 100%
  );
  opacity: 0.8;
  transform: scale(0.98);
}

/* 单打排名 - 橙色 (选中状态) */
.ranking-tabs .van-col:nth-child(2) .tab-item.active {
  background: linear-gradient(135deg, #ff8c00 0%, #e67300 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(255, 140, 0, 0.6);
  opacity: 1;
  transform: scale(1.05) translateY(-2px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

/* 双打排名 - 蓝色 (未选中状态) */
.ranking-tabs .van-col:nth-child(3) .tab-item {
  background: linear-gradient(
    135deg,
    rgba(74, 144, 226, 0.3) 0%,
    rgba(53, 122, 189, 0.3) 100%
  );
  color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 1px 4px rgba(74, 144, 226, 0.2);
}

.ranking-tabs .van-col:nth-child(3) .tab-item:hover {
  background: linear-gradient(
    135deg,
    rgba(74, 144, 226, 0.5) 0%,
    rgba(53, 122, 189, 0.5) 100%
  );
  opacity: 0.8;
  transform: scale(0.98);
}

/* 双打排名 - 蓝色 (选中状态) */
.ranking-tabs .van-col:nth-child(3) .tab-item.active {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(74, 144, 226, 0.6);
  opacity: 1;
  transform: scale(1.05) translateY(-2px);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

/* 项目切换 */
.event-selector {
  display: flex;
  background: #333;
  padding: 8px 20px;
  gap: 24px;
  border-bottom: 1px solid #444;
}

.event-item {
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.event-item span {
  font-size: 14px;
  font-weight: 500;
  color: #999;
  padding: 8px 0;
  display: block;
  transition: color 0.3s ease;
}

.event-item.active span {
  color: #fff;
  font-weight: 600;
}

.event-item:hover span {
  color: #ff4444;
}

.underline {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #ff4444 0%, #cc3333 100%);
  border-radius: 1px;
  transform: scaleX(1);
  transition: transform 0.3s ease;
}

/* 搜索框容器 */
.search-container {
  background: #333;
  padding: 8px 16px 12px;
  border-bottom: 1px solid #444;
}

.search-container .van-search {
  padding: 0;
}

.search-container .van-search__content {
  background: #2a2a2a;
  border: 1px solid #444;
}

.search-container .van-field__control {
  color: #fff;
}

.search-container .van-field__control::placeholder {
  color: #666;
}

.search-container .van-icon {
  color: #999;
}

/* 无结果提示 */
.no-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.no-result p {
  margin-top: 16px;
  font-size: 14px;
  color: #999;
}

/* 空状态提示 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  min-height: 400px;
}

.empty-icon {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: #999;
  margin-bottom: 8px;
}

.empty-hint {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

/* 会员推广横幅 */
.vip-promotion-banner {
  margin: 16px 16px 20px 16px;
  cursor: pointer;
  animation: slideInDown 0.6s ease-out;
}

.vip-banner-bg {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  border-radius: 16px;
  padding: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4),
    0 4px 12px rgba(118, 75, 162, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.vip-banner-bg::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 70%
  );
  animation: vipRotate 8s linear infinite;
}

.vip-promotion-banner:hover .vip-banner-bg {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(102, 126, 234, 0.5),
    0 6px 16px rgba(118, 75, 162, 0.4);
}

.vip-promotion-banner:active .vip-banner-bg {
  transform: translateY(-2px) scale(1.01);
}

.vip-banner-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 1;
}

.vip-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.vip-icon {
  color: #fff;
  animation: vipIconPulse 2s ease-in-out infinite;
}

.vip-sparkle {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 20px;
  animation: vipSparkle 1.5s ease-in-out infinite;
}

.vip-text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.vip-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.vip-highlight {
  background: linear-gradient(90deg, #fff 0%, #ffe5ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: vipTextShine 3s ease-in-out infinite;
}

.vip-separator {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.vip-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.vip-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.vip-promotion-banner:hover .vip-arrow {
  transform: translateX(4px);
  background: rgba(255, 255, 255, 0.3);
}

.vip-banner-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: vipShine 3s ease-in-out infinite;
}

/* 会员横幅动画 */
@keyframes slideInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes vipRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes vipIconPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes vipSparkle {
  0%,
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.2) rotate(180deg);
  }
}

@keyframes vipTextShine {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes vipShine {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

/* 卡片进入动画 */
@keyframes slideInUp {
  0% {
    opacity: 0;
    transform: translateY(30px) skewX(-2deg) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) skewX(-2deg) scale(1);
  }
}

@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: translateY(20px) skewX(-2deg) scale(0.8);
  }
  50% {
    opacity: 0.7;
    transform: translateY(-5px) skewX(-2deg) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) skewX(-2deg) scale(1);
  }
}

.card-enter {
  animation: fadeInScale 0.6s ease-out forwards;
  animation-fill-mode: both;
  opacity: 0;
}

/* 响应式动画优化 */
@media (prefers-reduced-motion: reduce) {
  .card-enter {
    animation: slideInUp 0.3s ease-out forwards;
  }

  @keyframes slideInUp {
    0% {
      opacity: 0;
      transform: translateY(10px) skewX(-2deg);
    }
    100% {
      opacity: 1;
      transform: translateY(0) skewX(-2deg);
    }
  }
}

/* 移动端优化 */
@media (max-width: 768px) {
  .card-enter {
    animation-duration: 0.4s;
  }
}

/* 🎨 底部导航栏 - 彩虹渐变 */
.bottom-nav {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-top: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

.bottom-nav .van-tabbar-item {
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.bottom-nav .van-tabbar-item--active {
  color: #fff;
  font-weight: 700;
  animation: navItemJump 0.6s ease-in-out;
}

@keyframes navItemJump {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* 🌟 星星装饰 */
.ranking-tabs-wrapper::before {
  content: "⭐";
  position: absolute;
  top: 8px;
  right: 15px;
  font-size: 22px;
  animation: starTwinkle 2s ease-in-out infinite;
  z-index: 1;
}

@keyframes starTwinkle {
  0%,
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2) rotate(180deg);
  }
}

/* 🌟 额外星星装饰 */
.ranking-tabs-wrapper::after {
  content: "✨";
  position: absolute;
  top: 8px;
  left: 15px;
  font-size: 20px;
  animation: sparkle 1.5s ease-in-out infinite;
  z-index: 1;
}

@keyframes sparkle {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* 🎪 彩虹装饰 */
.header::before {
  content: "🌈";
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 24px;
  animation: rainbowBounce 3s ease-in-out infinite;
}

@keyframes rainbowBounce {
  0%,
  100% {
    transform: translateY(-50%) scale(1);
  }
  50% {
    transform: translateY(-55%) scale(1.1);
  }
}

/* 🎯 目标装饰 */
.filter-section::after {
  content: "🎯";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 22px;
  animation: targetSpin 4s linear infinite;
}

@keyframes targetSpin {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
}

/* 🔥 火焰装饰 */
.filter-section::before {
  content: "🔥";
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  animation: fireFlicker 1s ease-in-out infinite;
}

@keyframes fireFlicker {
  0%,
  100% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
  50% {
    opacity: 0.7;
    transform: translateY(-52%) scale(1.1);
  }
}

/* 🚀 火箭装饰 */
.search-container::before {
  content: "🚀";
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  animation: rocketFly 3s ease-in-out infinite;
}

@keyframes rocketFly {
  0%,
  100% {
    transform: translateY(-50%) translateX(0);
  }
  50% {
    transform: translateY(-55%) translateX(5px);
  }
}

/* 🎨 画笔装饰 */
.event-selector::after {
  content: "🎨";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-size: 20px;
  animation: brushPaint 2.5s ease-in-out infinite;
}

@keyframes brushPaint {
  0%,
  100% {
    transform: translateY(-50%) rotate(0deg);
  }
  25% {
    transform: translateY(-50%) rotate(-15deg);
  }
  75% {
    transform: translateY(-50%) rotate(15deg);
  }
}

/* 🎵 音符装饰 */
.top-header::after {
  content: "🎵";
  position: absolute;
  top: 50%;
  right: 60px;
  transform: translateY(-50%);
  font-size: 18px;
  animation: musicNote 2s ease-in-out infinite;
}

@keyframes musicNote {
  0%,
  100% {
    transform: translateY(-50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateY(-60%) scale(1.2);
    opacity: 0.7;
  }
}

/* 🏆 奖杯装饰 */
.group-records::before {
  content: "🏆";
  position: fixed;
  top: 15%;
  left: 10%;
  font-size: 35px;
  opacity: 0.25;
  animation: trophyFloat 12s ease-in-out infinite;
  z-index: 0;
  pointer-events: none;
  max-width: 35px; /* 限制宽度 */
}

@keyframes trophyFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(10deg);
  }
}

/* 🏸 羽毛球装饰 - 右上角飞舞 */
.group-records::after {
  content: "🏸";
  position: fixed;
  top: 25%;
  right: 10%;
  font-size: 30px;
  opacity: 0.25;
  animation: shuttlecockFly 4s ease-in-out infinite;
  z-index: 0;
  pointer-events: none;
}

@keyframes shuttlecockFly {
  0%,
  100% {
    transform: translateY(0) translateX(0) rotate(0deg);
  }
  25% {
    transform: translateY(-15px) translateX(-10px) rotate(-20deg);
  }
  50% {
    transform: translateY(-25px) translateX(0) rotate(0deg);
  }
  75% {
    transform: translateY(-15px) translateX(10px) rotate(20deg);
  }
}

/* 🏸 羽毛球装饰 - 左下角 */
.filter-section .filter-row::after {
  content: "🏸";
  position: fixed;
  bottom: 15%;
  right: 8%;
  font-size: 35px;
  opacity: 0.15;
  animation: shuttlecockBounce 3s ease-in-out infinite;
  z-index: 0;
  pointer-events: none;
}

@keyframes shuttlecockBounce {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 🏸 羽毛球装饰 - 中间飘动 */
.event-selector .event-item:nth-child(2)::before {
  content: "🏸";
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  animation: shuttlecockSwing 2.5s ease-in-out infinite;
}

@keyframes shuttlecockSwing {
  0%,
  100% {
    transform: translateX(-50%) translateY(0) rotate(0deg);
  }
  25% {
    transform: translateX(-60%) translateY(-5px) rotate(-15deg);
  }
  75% {
    transform: translateX(-40%) translateY(-5px) rotate(15deg);
  }
}

/* 🏸 羽毛球装饰 - 搜索框旁 */
.search-container .van-search::after {
  content: "🏸";
  position: absolute;
  top: 50%;
  right: 50px;
  transform: translateY(-50%);
  font-size: 16px;
  opacity: 0.4;
  animation: shuttlecockFloat 3s ease-in-out infinite;
  pointer-events: none;
}

@keyframes shuttlecockFloat {
  0%,
  100% {
    transform: translateY(-50%) translateX(0);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-55%) translateX(-5px);
    opacity: 0.7;
  }
}

/* 🏸 羽毛球装饰 - 榜单卡片飞过效果 */
.group-record-card.gold .ranking-display::after,
.group-record-card.silver .ranking-display::after,
.group-record-card.bronze .ranking-display::after {
  content: "🏸";
  position: absolute;
  top: 50%;
  right: -25px;
  transform: translateY(-50%) skewX(2deg);
  font-size: 16px;
  opacity: 0.5;
  animation: shuttlecockPass 4s ease-in-out infinite;
}

@keyframes shuttlecockPass {
  0%,
  100% {
    transform: translateY(-50%) skewX(2deg) translateX(0) rotate(0deg);
    opacity: 0.5;
  }
  50% {
    transform: translateY(-50%) skewX(2deg) translateX(-10px) rotate(-30deg);
    opacity: 0.8;
  }
}

@keyframes shuttlecockDance {
  0%,
  100% {
    transform: translateY(-50%) rotate(0deg);
    opacity: 0.6;
  }
  33% {
    transform: translateY(-60%) rotate(-120deg);
    opacity: 1;
  }
  66% {
    transform: translateY(-40%) rotate(120deg);
    opacity: 0.8;
  }
}

/* 🏸 羽毛球装饰 - 背景大羽毛球 */
.ranking-tabs-wrapper .ranking-tabs::before {
  content: "🏸";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 80px;
  opacity: 0.05;
  animation: shuttlecockRotate 20s linear infinite;
  z-index: 0;
  pointer-events: none;
}

@keyframes shuttlecockRotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

/* 🏸 羽毛球装饰 - 筛选器旁边 */
.filter-section .filter-row .filter-item:first-child::before {
  content: "🏸";
  position: absolute;
  top: -8px;
  left: -8px;
  font-size: 14px;
  animation: shuttlecockTwirl 2s ease-in-out infinite;
}

@keyframes shuttlecockTwirl {
  0%,
  100% {
    transform: rotate(0deg) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: rotate(180deg) scale(1.2);
    opacity: 0.8;
  }
}

/* 🎈 气球装饰 - 左侧 */
.event-selector::before {
  content: "🎈";
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 22px;
  animation: balloonFloat 4s ease-in-out infinite;
}

@keyframes balloonFloat {
  0%,
  100% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(-60%);
  }
}

/* 🎁 礼物装饰 */
.search-container::after {
  content: "🎁";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  animation: giftShake 3s ease-in-out infinite;
}

@keyframes giftShake {
  0%,
  100% {
    transform: translateY(-50%) rotate(0deg);
  }
  25% {
    transform: translateY(-50%) rotate(-5deg);
  }
  75% {
    transform: translateY(-50%) rotate(5deg);
  }
}

/* 💎 钻石装饰 */
.header::after {
  content: "💎";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  animation: diamondShine 2s ease-in-out infinite;
}

@keyframes diamondShine {
  0%,
  100% {
    opacity: 0.8;
    transform: translateY(-50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translateY(-50%) scale(1.15);
  }
}

/* 🌟 流星装饰 */
.top-header::before {
  content: "🌟";
  position: absolute;
  top: 50%;
  left: 60px;
  transform: translateY(-50%);
  font-size: 18px;
  animation: shootingStar 3s ease-in-out infinite;
}

@keyframes shootingStar {
  0%,
  100% {
    transform: translateY(-50%) translateX(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-50%) translateX(10px);
    opacity: 0.5;
  }
}

/* 🎪 羽毛球主题装饰 - 浮动在背景 */
.record-page .filter-section {
  position: relative;
}

.filter-section .filter-row::before {
  content: "🏸";
  position: fixed;
  bottom: 20%;
  left: 8%;
  font-size: 40px;
  opacity: 0.15;
  animation: shuttlecockLarge 8s ease-in-out infinite;
  z-index: 0;
  pointer-events: none;
  max-width: 40px; /* 限制宽度 */
}

@keyframes shuttlecockLarge {
  0%,
  100% {
    transform: translateY(0) rotate(0deg) scale(1);
  }
  25% {
    transform: translateY(-20px) rotate(-30deg) scale(1.1);
  }
  50% {
    transform: translateY(-30px) rotate(0deg) scale(1.15);
  }
  75% {
    transform: translateY(-20px) rotate(30deg) scale(1.1);
  }
}

@keyframes shuttlecockBounce {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 🌺 花朵装饰 */
.event-selector .event-item:first-child::before {
  content: "🌺";
  position: absolute;
  top: -5px;
  left: -5px;
  font-size: 16px;
  animation: flowerBloom 4s ease-in-out infinite;
}

@keyframes flowerBloom {
  0%,
  100% {
    transform: scale(0.8) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: scale(1) rotate(180deg);
    opacity: 1;
  }
}

/* 🦋 蝴蝶装饰 */
.event-selector .event-item:last-child::after {
  content: "🦋";
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 16px;
  animation: butterflyFly 5s ease-in-out infinite;
}

@keyframes butterflyFly {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-5px) rotate(-10deg);
  }
  75% {
    transform: translateY(-3px) rotate(10deg);
  }
}

/* 🍭 棒棒糖装饰 */
.ranking-tabs .van-col:nth-child(2) .tab-item::before {
  content: "🍭";
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  animation: lollipopSpin 3s linear infinite;
}

@keyframes lollipopSpin {
  0% {
    transform: translateX(-50%) rotate(0deg);
  }
  100% {
    transform: translateX(-50%) rotate(360deg);
  }
}

/* 🎂 蛋糕装饰 */
.ranking-tabs .van-col:nth-child(3) .tab-item::after {
  content: "🎂";
  position: absolute;
  bottom: -8px;
  right: 5px;
  font-size: 16px;
  animation: cakeBounce 2s ease-in-out infinite;
}

@keyframes cakeBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

/* 🌈 彩虹线条装饰 */
.group-record-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #ff6b9d 0%, #feca57 50%, #74b9ff 100%);
  border-radius: 2px 0 0 2px;
  animation: rainbowPulse 3s ease-in-out infinite;
}

@keyframes rainbowPulse {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

/* 💫 闪光效果 */
.group-record-card.gold::after,
.group-record-card.silver::after,
.group-record-card.bronze::after {
  content: "✨";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) skewX(2deg);
  font-size: 20px;
  animation: shimmer 2s ease-in-out infinite;
}

@keyframes shimmer {
  0%,
  100% {
    opacity: 0.3;
    transform: translateY(-50%) skewX(2deg) scale(0.8);
  }
  50% {
    opacity: 1;
    transform: translateY(-50%) skewX(2deg) scale(1.2);
  }
}

/* 🎊 彩带效果 - 前三名特殊动画 */
.group-record-card.gold,
.group-record-card.silver,
.group-record-card.bronze {
  position: relative;
  overflow: visible;
}

.group-record-card.gold .medal-icon::after {
  content: "🎊";
  position: absolute;
  top: -10px;
  left: -10px;
  font-size: 14px;
  animation: confetti 3s ease-in-out infinite;
}

@keyframes confetti {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.5;
  }
  50% {
    transform: translateY(-5px) rotate(180deg);
    opacity: 1;
  }
}
/deep/ .van-field__control {
  color: #fff;
}
/* 返回顶部悬浮按钮 - 固定右下角 */
.back-to-top-fab {
  position: fixed;
  bottom: 30px;
  right: 20px;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.6),
    0 4px 12px rgba(118, 75, 162, 0.4), inset 0 -2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 9999;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  animation: fabFloat 3s ease-in-out infinite, fabGlow 2s ease-in-out infinite;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}
.back-to-top-fab::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #667eea, #764ba2, #f093fb, #667eea);
  border-radius: 50%;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
  animation: fabRotate 3s linear infinite;
}
.back-to-top-fab:hover::before {
  opacity: 1;
}
.back-to-top-fab:hover {
  transform: translateY(-10px) scale(1.15) rotate(5deg);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.8),
    0 6px 20px rgba(118, 75, 162, 0.6), 0 0 0 12px rgba(102, 126, 234, 0.1),
    inset 0 -2px 8px rgba(0, 0, 0, 0.15);
}
.back-to-top-fab:active {
  transform: translateY(-6px) scale(1.08);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.7),
    0 4px 12px rgba(118, 75, 162, 0.5);
}
.fab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3px;
  animation: fabIconBounce 2s ease-in-out infinite;
}
.fab-icon .van-icon {
  color: #fff;
  font-weight: bold;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}
.fab-text {
  font-size: 11px;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  text-transform: uppercase;
} /* 悬浮按钮浮动动画 */
@keyframes fabFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-5px) rotate(-2deg);
  }
  50% {
    transform: translateY(-8px) rotate(0deg);
  }
  75% {
    transform: translateY(-5px) rotate(2deg);
  }
} /*
悬浮按钮发光动画 */
@keyframes fabGlow {
  0%,
  100% {
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.6),
      0 4px 12px rgba(118, 75, 162, 0.4), inset 0 -2px 8px rgba(0, 0, 0, 0.1);
  }
  50% {
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.8),
      0 4px 12px rgba(118, 75, 162, 0.6), 0 0 20px rgba(240, 147, 251, 0.4),
      inset 0 -2px 8px rgba(0, 0, 0, 0.1);
  }
} /* 边框旋转动画 */
@keyframes fabRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} /* 图标跳动动画
*/
@keyframes fabIconBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
} /* 淡入缩放过渡动画 */
.fade-scale-enter-active {
  animation: fadeScaleIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.fade-scale-leave-active {
  animation: fadeScaleOut 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes fadeScaleIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(30px) rotate(-180deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0) rotate(0deg);
  }
}
@keyframes fadeScaleOut {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0) rotate(0deg);
  }
  100% {
    opacity: 0;
    transform: scale(0.3) translateY(30px) rotate(180deg);
  }
}
</style>

<style scoped>
/* 组件内样式 - 只影响 MeNewIndex 组件 */
/* 通过 scoped 确保样式不会泄漏到其他组件 */
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/MeNewIndex.vue